module.exports = __webpack_public_path__ + "static/media/reqPay.be8b1ea5.svg";